import React from "react";
import { useSelector } from "react-redux";

const useGetCurrentUser = () => useSelector((state) => state.user.user.me);

export default useGetCurrentUser;
